import { useContext, useEffect } from "react";

import { TopbarBackContext, TopbarBackSetContext, type TopbarBackLink } from "@/state/topbarBack";

/** Read the active topbar back link (used by the Topbar). */
export function useTopbarBackLink(): TopbarBackLink | null {
  return useContext(TopbarBackContext);
}

/**
 * Register a back call-to-action in the topbar's left slot while the calling
 * page is mounted; the slot clears automatically on unmount. Pass `null` to show
 * no back link. Depends on the primitive `to`/`label` so a fresh object literal
 * each render does not re-fire the effect.
 */
export function useTopbarBack(link: TopbarBackLink | null): void {
  const setBack = useContext(TopbarBackSetContext);
  const to = link?.to ?? null;
  const label = link?.label ?? null;

  useEffect(() => {
    setBack(to && label ? { to, label } : null);
    return () => setBack(null);
  }, [setBack, to, label]);
}
